// extracted by mini-css-extract-plugin
module.exports = {"CartHeader":"HeaderWithTitleAndBackChevron_CartHeader__3HP-h","IconStyle":"HeaderWithTitleAndBackChevron_IconStyle__jGAI3"};